var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSleepFilled = function SvgSleepFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11.823 21.875c-4.499 0-8.478-3.019-9.677-7.341a.5.5 0 0 1 .713-.577c1.17.612 2.43.922 3.746.922 4.448 0 8.067-3.603 8.067-8.032a8 8 0 0 0-1.062-3.973.5.5 0 0 1 .549-.735c4.542 1.079 7.714 5.078 7.714 9.727 0 5.519-4.508 10.01-10.05 10.01ZM7.16 10.621a.5.5 0 0 1-.5-.5c0-1.935-.94-2.875-2.877-2.875a.5.5 0 0 1 0-1c1.936 0 2.877-.94 2.877-2.875a.5.5 0 0 1 1 0c0 1.934.941 2.875 2.878 2.875a.5.5 0 0 1 0 1c-1.937 0-2.878.94-2.878 2.875a.5.5 0 0 1-.5.5Z"
  })));
};
export default SvgSleepFilled;